import { graphql } from '@apollo/client/react/hoc'

import { graphene } from 'graphql/tags'

export const MUTATION_NAME = 'batchUpdateOrderRetailerAccount'

const batchUpdateOrderRetailerAccount = graphene`#graphql
  mutation BatchUpdateOrderRetailerAccount(
    $input: BatchUpdateOrderRetailerAccountInput!
  ) {
    batchUpdateOrderRetailerAccount(input: $input) {
      updatedOrders {
        id
      }
      notUpdatedOrders {
        id
      }
    }
  }
`

const withUpdateOrderRetailerAccountMutation = graphql(
  batchUpdateOrderRetailerAccount,
  {
    props: ({ mutate }) => ({
      handleUpdateOrderRetailerAccount: ({
        selectedOrdersIds,
        contactEmail,
        selectedRetailerId,
        keepAddressInfo,
      }) =>
        mutate({
          variables: {
            input: {
              orderIds: selectedOrdersIds,
              buyerEmailAddress: contactEmail,
              retailerAccountId: selectedRetailerId,
              keepAddressInfo,
            },
          },
        }),
    }),
  },
)

export default withUpdateOrderRetailerAccountMutation
